import React from "react";
import { Form, InputGroup } from "react-bootstrap";
import Required from "../../Required";
import Fontstyling from "../comman";

const CustomInputField = ({
  label,
  name,
  maxLength,
  value,
  handleChange,
  handleBlur,
  placeholder,
  touched,
  errors,
  isRequired,
  disabled,
  isAmount,
}) => {
  return (
    <>
      <Form.Group className="text-start">
        <Form.Label className="text-nowrap" style={Fontstyling.label}>
          {label}
          {isRequired && <Required />}
        </Form.Label>
        <InputGroup>
          {isAmount && <InputGroup.Text className="py-0 fw-bold">$</InputGroup.Text>}
          <Form.Control
            className="py-1 rounded-0"
            style={{...Fontstyling.label,zIndex:0}}
            name={name}
            value={value[name]}
            onChange={handleChange}
            onBlur={handleBlur}
            type="text"
            maxLength={maxLength}
            placeholder={placeholder ?? label}
            isInvalid={touched[name] && errors[name]}
            disabled={disabled}
          />
          <Form.Control.Feedback type="invalid">
            {errors[name]}
          </Form.Control.Feedback>
        </InputGroup>
      </Form.Group>
    </>
  );
};

export default CustomInputField;
